// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2A7Ic","inputWrap":"styles_inputWrap__2_6Ss","input":"styles_input__1xT28"};